var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProjects(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "470px",
    height: "469px",
    viewBox: "0 0 470 469",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "projects"
  }, /*#__PURE__*/React.createElement("g", {
    id: "photo-1579714996298-5f25255e98a4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask",
    transform: "translate(0.000000, 211.000000)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 470,
    height: 258,
    rx: 20
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 184,
    width: 470,
    height: 51
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 470,
    height: 235,
    rx: 20
  }))), /*#__PURE__*/React.createElement("g", {
    id: "2-more-projects",
    transform: "translate(271.000000, 416.000000)",
    fill: "#FFFFFF",
    fontFamily: "AvenirNext-Regular, Avenir Next",
    fontSize: 18,
    fontWeight: "normal"
  }, /*#__PURE__*/React.createElement("text", null, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2 more projects"))), /*#__PURE__*/React.createElement("g", {
    id: "arrow-right",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    transform: "translate(421.000000, 422.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,8 L16,8",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    points: "8 0 16 8 8 16"
  })), /*#__PURE__*/React.createElement("g", {
    id: "D\\xE9veloppement-d\\u2019une",
    transform: "translate(98.000000, 291.000000)",
    fill: "#FFFFFF",
    fontFamily: "AvenirNext-Bold, Avenir Next",
    fontSize: 32,
    fontWeight: "bold"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Mobile-app"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 32
  }, "Mobile app")), /*#__PURE__*/React.createElement("text", {
    id: "for-a-smart-watch"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 74
  }, "for a smart watch")))), /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-smart-watch-square-wifi-alternate@140x140",
    transform: "translate(162.000000, 19.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147,49.0000002 C147,35.4690171 136.030976,24.4999956 122.5,24.5000002 L113.696333,24.4999956 C112.783436,24.5006679 111.981972,23.8928916 111.736333,23.0136625 L106.003333,2.98083306 C105.510258,1.22242601 103.909557,0.00522600562 102.083333,3.01308823e-07 L44.9166667,3.01308823e-07 C43.0919941,-0.000492903667 41.4884602,1.2096582 40.9885,2.96449973 L35.2718333,23.0136625 C35.0270721,23.9004559 34.215387,24.5108967 33.2955,24.4999956 L24.5,24.5000002 C10.9690236,24.4999956 0,35.4690171 0,49.0000002 L0,146.999972 C0,160.530946 10.9690236,171.499967 24.5,171.499967 L33.2955,171.499967 C34.2061025,171.498267 35.0068225,172.102143 35.2555,172.978134 L40.9721667,193.035463 C41.473773,194.796146 43.0859423,196.007776 44.9166667,195.999963 L102.083333,195.999963 C103.904977,195.996811 105.504205,194.787395 106.003333,193.035463 L111.72,172.978134 C111.971072,172.103786 112.770319,171.501021 113.68,171.499967 L122.5,171.499967 C136.030976,171.499967 147,160.530946 147,146.999972 L147,49.0000002 Z M130.666667,146.999972 C130.666667,151.510297 127.010325,155.166637 122.5,155.166637 L24.5,155.166637 C19.9896745,155.166637 16.3333333,151.510297 16.3333333,146.999972 L16.3333333,48.9999909 C16.3333333,44.4896663 19.9896745,40.8333258 24.5,40.8333258 L122.5,40.8333258 C127.010325,40.8333258 130.666667,44.4896663 130.666667,48.9999909 L130.666667,146.999972 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,123 C65,127.418278 68.581722,131 73,131 C77.418278,131 81,127.418278 81,123 C81,118.581722 77.418278,115 73,115 C68.581722,115 65,118.581722 65,123 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.553348,78.9707795 C88.2990916,61.6764068 57.7617771,61.6764068 36.507521,78.9707795 C34.6858684,80.2996 33.7453589,82.5187542 34.0598698,84.7460701 C34.3743806,86.973386 35.8929455,88.8479276 38.0118949,89.6245155 C40.1308443,90.4011034 42.5068032,89.9538917 44.1952654,88.4606588 C60.9774321,74.8114595 85.0834366,74.8114595 101.865603,88.4606588 C103.559542,89.919346 105.917275,90.341406 108.015004,89.561469 C110.112733,88.781532 111.616385,86.9238065 111.936806,84.7161787 C112.257228,82.5085509 111.343389,80.3025955 109.553348,78.9626406 L109.553348,78.9707795 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5389263,98.0848404 C82.1324862,87.3050532 62.8675138,87.3050532 49.4610737,98.0848404 C47.6604809,99.4163694 46.741256,101.608453 47.0635661,103.802199 C47.3858761,105.995945 48.8983916,107.841989 51.0084852,108.617021 C53.1185788,109.392054 55.4902085,108.972648 57.1941323,107.523133 C66.1021238,100.3656 78.8978762,100.3656 87.8058677,107.523133 C89.5097915,108.972648 91.8814212,109.392054 93.9915148,108.617021 C96.1016084,107.841989 97.6141239,105.995945 97.9364339,103.802199 C98.258744,101.608453 97.3395191,99.4163694 95.5389263,98.0848404 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.9139bdf46099eaa8a7944d593ecd794b.svg";
export { ForwardRef as ReactComponent };